import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/lems-v1/images/calendar.svg'


const _hoisted_1 = { class: "w50 pd-rt-7 chart-box" }
const _hoisted_2 = { class: "created-resolved-chart" }
const _hoisted_3 = { class: "chart-top" }
const _hoisted_4 = { class: "chart-top-lt" }
const _hoisted_5 = { class: "chart-top-rt" }
const _hoisted_6 = { class: "calendar-drop-down-content" }
const _hoisted_7 = { class: "calendar-drop-down-content-inner" }
const _hoisted_8 = { class: "choose-calendar" }
const _hoisted_9 = { class: "custom-filter" }
const _hoisted_10 = { class: "chart-btm" }
const _hoisted_11 = { class: "chart-show-container" }
const _hoisted_12 = {
  ref: "chartCanvas",
  width: "400",
  height: "200"
}
const _hoisted_13 = { class: "chart-table-view" }
const _hoisted_14 = { class: "created-resolved-table" }
const _hoisted_15 = { class: "c-r-table-hd c-r-table-row" }
const _hoisted_16 = { class: "c-r-table-body" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["data-title"]
const _hoisted_19 = ["data-title"]
const _hoisted_20 = ["data-title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.constants.CREATED_VS_RESOLVED_ISSUES_REPORT_TEXT), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.constants.CREATED_RESOLVED_CHART_TEXT), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["calendar-drop-down-box", { 'show-calendar-dropdown': _ctx.isCalendarOpen }])
          }, [
            _createElementVNode("div", {
              class: "calendar-drop-down-icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCalendarOpen = !_ctx.isCalendarOpen))
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)
            ]))]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_DatePicker, {
                    modelValue: _ctx.selectedDate,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDate) = $event)),
                      _ctx.validateDate
                    ],
                    inline: "",
                    "max-date": new Date()
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "max-date"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    id: "allCalendarBtn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterData('all')))
                  }, "All"),
                  _createElementVNode("button", {
                    id: "lastWeekCalendarBtn",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterData('last_week')))
                  }, "Last Week"),
                  _createElementVNode("button", {
                    id: "lastMonthCalendarBtn",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterData('last_month')))
                  }, "Last Month"),
                  _createElementVNode("button", {
                    id: "lastYearCalendarBtn",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filterData('last_year')))
                  }, "Last Year")
                ])
              ])
            ])
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("canvas", _hoisted_12, null, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, _toDisplayString(_ctx.constants.PERIOD_TEXT), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.constants.CREATED_TEXT), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.constants.RESOLVED_TEXT), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "c-r-table-row",
                onClick: ($event: any) => (_ctx.openIssuesPopup(item)),
                style: {"cursor":"pointer"}
              }, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", {
                    "data-title": _ctx.constants.PERIOD_TEXT || 'Period'
                  }, _toDisplayString(item.period), 9, _hoisted_18),
                  _createElementVNode("li", {
                    "data-title": _ctx.constants.CREATED_TEXT || 'Created'
                  }, _toDisplayString(item.created), 9, _hoisted_19),
                  _createElementVNode("li", {
                    "data-title": _ctx.constants.RESOLVED_TEXT || 'Resolved'
                  }, _toDisplayString(item.resolved), 9, _hoisted_20)
                ])
              ], 8, _hoisted_17))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}